import { ContentProps } from '@helper/util/landing/types'

import Container from '@/landing/component/container'
import Heading from '@/landing/component/heading'

import Boarding from '@/landing/template/about/AboutBoarding'
import Hero from '@/landing/template/about/AboutHero'
import MapLocation from '@/landing/template/about/AboutMap'

type Props = {
    contents: ContentProps;
}

const Landing = ({ contents }:Props) => {
  const { aboutLabel, aboutCaption } = contents
  return (
        <Container>
            <Heading caption={aboutCaption} label={aboutLabel} />
            <Hero contents={contents} />
            {/* <Boarding contents={contents} /> */}
            <MapLocation contents={contents} />
        </Container>
  )
}

export default Landing
